import React from 'react';
import { Navbar } from './index';
import { Footer } from './index';

const LandingLayout = (props) => {
  return (
    <>
      <Navbar />
      {props.children}
      <Footer />
    </>
  );
};

export default LandingLayout;
